import React from "react";
import PropTypes from "prop-types";
import styles from './lazyload-image.css';

export default class StaticImage extends React.Component {
  render() {
    let containerClassName = this.props.containerClassName || '';
    let image = this.props.image || '';
    let imageId = image.split('/').pop().split('~').shift();
    let altText = this.props.alt;
    let { ariaHidden, img_ratio, mdCrop, smCrop } = this.props;

    return (<div className={styles[containerClassName]} aria-hidden={ariaHidden} style={img_ratio && parseInt(img_ratio) ? {paddingBottom: img_ratio, height: 0} : {}}>
        <picture>
          <source srcSet={`https://www.theknot.com/tk-media/images/${imageId}~${mdCrop}`} media="(min-width: 768px)" />
          <source srcSet={`https://www.theknot.com/tk-media/images/${imageId}~${smCrop}`} media="(min-width: 0px)" />

          <img alt={altText} src={`https://www.theknot.com/tk-media/images/${imageId}~${mdCrop}`}/>
        </picture>
      </div>);
  }
};

StaticImage.propTypes = {
  containerClassName: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string
};

